import * as React from "react"
import * as Antd from "antd"
import styles from "./DvUserAvatarBackoffice.module.scss"

interface IProps extends Antd.AvatarProps {
	className?: string
}

const DvUserAvatarBackoffice: React.FC<IProps> = (props) => {
	return (
		<Antd.Avatar
			{...props}
			className={`${styles.dv_user_avatar_backoffice} ${props.className || ""}`}
			src="https://membership.elglobodistrict.com/assets/images/globo_backoffice_avatar.jpg"
		>
			B
		</Antd.Avatar>
	)
}

export default React.memo(DvUserAvatarBackoffice)
